import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
import { ModelApi } from '@/api/ai/model/model';
import ModelForm from './ModelForm.vue';
import { DICT_TYPE } from '@/utils/dict';
import { ApiKeyApi } from '@/api/ai/model/apiKey';
import { onMounted, reactive, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
import Icon from '@/components/Icon/src/Icon.vue';
/** API 模型列表 */
export default /*@__PURE__*/_defineComponent({
  ...{
    name: 'AiModel'
  },
  __name: 'index',
  setup(__props) {
    const message = useMessage(); // 消息弹窗
    // const { t } = useI18n() // 国际化
    const loading = ref(true); // 列表的加载中
    const list = ref([]); // 列表的数据
    const total = ref(0); // 列表的总页数
    const queryParams = reactive({
      pageNo: 1,
      pageSize: 10,
      name: undefined,
      model: undefined,
      platform: undefined
    });
    const queryFormRef = ref(); // 搜索的表单
    const apiKeyList = ref([]); // API 密钥列表
    /** 查询列表 */
    const getList = async () => {
      loading.value = true;
      try {
        const data = await ModelApi.getModelPage(queryParams);
        list.value = data.list;
        total.value = data.total;
      } finally {
        loading.value = false;
      }
    };
    /** 搜索按钮操作 */
    const handleQuery = () => {
      queryParams.pageNo = 1;
      getList();
    };
    /** 重置按钮操作 */
    const resetQuery = () => {
      queryFormRef.value.resetFields();
      handleQuery();
    };
    /** 添加/修改操作 */
    const formRef = ref();
    const openForm = (type, id) => {
      formRef.value.open(type, id);
    };
    /** 删除按钮操作 */
    const handleDelete = async id => {
      try {
        // 删除的二次确认
        await message.delConfirm();
        // 发起删除
        await ModelApi.deleteModel(id);
        message.success('删除成功');
        // 刷新列表
        await getList();
      } catch {}
    };
    /** 初始化 **/
    onMounted(async () => {
      await getList();
      // 获得下拉数据
      apiKeyList.value = await ApiKeyApi.getApiKeySimpleList();
    });
    return (_ctx, _cache) => {
      const _component_doc_alert = _resolveComponent("doc-alert");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_ContentWrap = _resolveComponent("ContentWrap");
      const _component_dict_tag = _resolveComponent("dict-tag");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_Pagination = _resolveComponent("Pagination");
      const _directive_hasPermi = _resolveDirective("hasPermi");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_doc_alert, {
        title: "AI 手册",
        url: "https://doc.iocoder.cn/ai/build/"
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_createVNode(_component_el_form, {
          class: "-mb-15px",
          model: queryParams,
          ref_key: "queryFormRef",
          ref: queryFormRef,
          inline: true,
          "label-width": "68px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "模型名字",
            prop: "name"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => queryParams.name = $event),
              placeholder: "请输入模型名字",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型标识",
            prop: "model"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => queryParams.model = $event),
              placeholder: "请输入模型标识",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "模型平台",
            prop: "platform"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: queryParams.platform,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => queryParams.platform = $event),
              placeholder: "请输入模型平台",
              clearable: "",
              onKeyup: _withKeys(handleQuery, ["enter"]),
              class: "!w-240px"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              onClick: handleQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:search",
                class: "mr-5px"
              }), _cache[6] || (_cache[6] = _createTextVNode(" 搜索"))]),
              _: 1
            }), _createVNode(_component_el_button, {
              onClick: resetQuery
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:refresh",
                class: "mr-5px"
              }), _cache[7] || (_cache[7] = _createTextVNode(" 重置"))]),
              _: 1
            }), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              type: "primary",
              plain: "",
              onClick: _cache[3] || (_cache[3] = $event => openForm('create'))
            }, {
              default: _withCtx(() => [_createVNode(Icon, {
                icon: "ep:plus",
                class: "mr-5px"
              }), _cache[8] || (_cache[8] = _createTextVNode(" 新增 "))]),
              _: 1
            })), [[_directive_hasPermi, ['ai:model:create']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])]),
        _: 1
      }), _createVNode(_component_ContentWrap, null, {
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: list.value,
          stripe: true,
          "show-overflow-tooltip": true
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            label: "所属平台",
            align: "center",
            prop: "platform",
            "min-width": "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).AI_PLATFORM,
              value: scope.row.platform
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "模型类型",
            align: "center",
            prop: "platform",
            "min-width": "100"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).AI_MODEL_TYPE,
              value: scope.row.type
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "模型名字",
            align: "center",
            prop: "name",
            "min-width": "180"
          }), _createVNode(_component_el_table_column, {
            label: "模型标识",
            align: "center",
            prop: "model",
            "min-width": "180"
          }), _createVNode(_component_el_table_column, {
            label: "API 秘钥",
            align: "center",
            prop: "keyId",
            "min-width": "140"
          }, {
            default: _withCtx(scope => [_createElementVNode("span", null, _toDisplayString(apiKeyList.value.find(item => item.id === scope.row.keyId)?.name), 1)]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "排序",
            align: "center",
            prop: "sort",
            "min-width": "80"
          }), _createVNode(_component_el_table_column, {
            label: "状态",
            align: "center",
            prop: "status",
            "min-width": "80"
          }, {
            default: _withCtx(scope => [_createVNode(_component_dict_tag, {
              type: _unref(DICT_TYPE).COMMON_STATUS,
              value: scope.row.status
            }, null, 8, ["type", "value"])]),
            _: 1
          }), _createVNode(_component_el_table_column, {
            label: "温度参数",
            align: "center",
            prop: "temperature",
            "min-width": "80"
          }), _createVNode(_component_el_table_column, {
            label: "回复数 Token 数",
            align: "center",
            prop: "maxTokens",
            "min-width": "140"
          }), _createVNode(_component_el_table_column, {
            label: "上下文数量",
            align: "center",
            prop: "maxContexts",
            "min-width": "100"
          }), _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            width: "180",
            fixed: "right"
          }, {
            default: _withCtx(scope => [_withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "primary",
              onClick: $event => openForm('update', scope.row.id)
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [_createTextVNode(" 编辑 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:model:update']]]), _withDirectives((_openBlock(), _createBlock(_component_el_button, {
              link: "",
              type: "danger",
              onClick: $event => handleDelete(scope.row.id)
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [_createTextVNode(" 删除 ")])),
              _: 2
            }, 1032, ["onClick"])), [[_directive_hasPermi, ['ai:model:delete']]])]),
            _: 1
          })]),
          _: 1
        }, 8, ["data"])), [[_directive_loading, loading.value]]), _createVNode(_component_Pagination, {
          total: total.value,
          page: queryParams.pageNo,
          "onUpdate:page": _cache[4] || (_cache[4] = $event => queryParams.pageNo = $event),
          limit: queryParams.pageSize,
          "onUpdate:limit": _cache[5] || (_cache[5] = $event => queryParams.pageSize = $event),
          onPagination: getList
        }, null, 8, ["total", "page", "limit"])]),
        _: 1
      }), _createVNode(ModelForm, {
        ref_key: "formRef",
        ref: formRef,
        onSuccess: getList
      }, null, 512)], 64);
    };
  }
});